/* Arjit4Amply: homepage Sleep Reset sign-up. On submit it
   1. sends email, first name and phone to Omnisend's own script
      (omnisend.identifyContact, from the Omnisend app embed) - the only
      route the phone number has into Omnisend. Omnisend keeps each phone
      number on one contact only, so a number already on another contact
      is silently not attached (the email sign-up still goes through);
   2. then lets the Shopify newsletter form submit normally, creating a
      Shopify customer who accepts email marketing, tagged for Omnisend's
      store sync (see the section's top comment).
   The submit has to be a real one (requestSubmit, not fetch or
   form.submit()): Shopify protects this form with an invisible hCaptcha
   whose script adds its token on the submit event - a background request
   or form.submit() skips it and Shopify rejects the sign-up ("Missing
   CAPTCHA token"). Shopify then returns to the homepage with
   ?customer_posted=true#SleepResetForm and the script shows "Check your
   inbox". The anchor matters: the exit popup is a second Shopify newsletter
   form on the same page, and Shopify's own form.posted_successfully? can't
   tell the two apart. */
document.querySelectorAll('.matre-home-sleep-reset__form').forEach(function (form) {
  var success = form.querySelector('.matre-home-sleep-reset__success');
  var again = form.querySelector('[data-reset-again]');
  var submit = form.querySelector('.matre-home-sleep-reset__submit');
  var handedToShopify = false;

  /* Omnisend only accepts international format (+6591234567). Strip spaces,
     dashes and brackets; an 8-digit number is treated as a Singapore
     number (+65), anything else without a "+" gets one added. */
  function normalisePhone(raw) {
    var hasPlus = raw.trim().charAt(0) === '+';
    var digits = raw.replace(/\D/g, '');
    if (!digits) return '';
    if (hasPlus) return '+' + digits;
    if (digits.length === 8) return '+65' + digits;
    return '+' + digits;
  }

  function sendToOmnisend() {
    var email = form.querySelector('[name="contact[email]"]').value.trim();
    var firstName = form.querySelector('[name="contact[first_name]"]').value.trim();
    var phone = normalisePhone(form.querySelector('[name="phone"]').value);
    if (!window.omnisend || typeof window.omnisend.identifyContact !== 'function') return false;
    var contact = { email: email };
    if (firstName) contact.firstName = firstName;
    if (phone) contact.phone = phone;
    try {
      window.omnisend.identifyContact(contact);
      return true;
    } catch (error) {
      return false;
    }
  }

  form.addEventListener('submit', function (event) {
    if (handedToShopify) return;
    event.preventDefault();
    if (submit) submit.disabled = true;

    /* Give Omnisend's request a moment to leave before the page navigates. */
    var wait = sendToOmnisend() ? 1200 : 0;
    setTimeout(function () {
      handedToShopify = true;
      if (submit) submit.disabled = false;
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submit || undefined);
      } else if (submit) {
        submit.click();
      }
    }, wait);
  });

  var postedHere = /[?&]customer_posted=true/.test(window.location.search) && window.location.hash === '#SleepResetForm';
  if (postedHere) {
    form.querySelectorAll('.matre-home-sleep-reset__fields, .matre-home-sleep-reset__submit, .matre-home-sleep-reset__consent').forEach(function (el) {
      el.hidden = true;
    });
    success.hidden = false;
    success.focus();
    /* Same flag the exit popup sets on its own sign-up, so the popup
       doesn't ask someone who has just signed up here. */
    try {
      localStorage.setItem('matre-exit-popup-subscribed', 'true');
    } catch (error) {}
  } else if (window.location.hash !== '#SleepResetForm') {
    /* A Shopify error message after the popup's sign-up belongs to the popup, not here. */
    var error = form.querySelector('.matre-home-sleep-reset__error');
    if (error) error.remove();
  }

  if (again) {
    again.addEventListener('click', function () {
      success.hidden = true;
      form.querySelectorAll('.matre-home-sleep-reset__fields, .matre-home-sleep-reset__submit, .matre-home-sleep-reset__consent').forEach(function (el) {
        el.hidden = false;
      });
      form.reset();
    });
  }
});
